import { render, staticRenderFns } from "./UploadDriversModal.vue?vue&type=template&id=8c59dc06"
import script from "./UploadDriversModal.vue?vue&type=script&lang=ts"
export * from "./UploadDriversModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports